import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { scenarioShowHurdleStore } from '../../storage/local/index';
import { useAppMutation } from '../use-app-mutation.hook';
import { useInvalidateQueries } from '../use-invalidate-queries.hook';

export const useDeleteScenarioInvestment = () => {
  const { invalidateQuery: invalidateViewQueries } = useInvalidateQueries(
    QueryKey.GET_SCENARIO_INVESTMENTS,
  );

  const { invalidateQuery: invalidateCalculationQueries } = useInvalidateQueries(
    QueryKey.GET_CONVERSION_SUMMARY,
    QueryKey.CALC_CUSTOM_SAFE,
    QueryKey.CALC_SCENARIO_SAFES,
    QueryKey.CALC_SCENARIO_INVESTMENT,
  );

  const { mutate: deleteScenarioInvestment, isPending } = useAppMutation(
    [QueryKey.DELETE_SCENARIO_INVESTMENT],
    {
      mutationFn: ({ scenarioId, investmentId }: { investmentId: string; scenarioId: string }) =>
        ApiService.delete({
          endpoint: BackendRoute.SCENARIOS,
          routePath: [scenarioId, 'investments', investmentId],
        }),
      onSuccess: () => {
        scenarioShowHurdleStore.delete();
        invalidateCalculationQueries();
        invalidateViewQueries();
      },
    },
  );
  return { deleteScenarioInvestment, isPending };
};
